// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"0eba9393","453":"0895875f","469":"17b11cd5"}[chunkId] + ".chunk.js";
};